module.exports = require("./az-Latn");